import React from "react";
import { CalDate } from "../../../utilities/functions";

function EndContract({ row }) {
  return <div>{row?.endDate ? CalDate(row?.endDate) : ""}</div>;
}

export default EndContract;
